function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { FlexBox, P, Icon } from "../";
export const Tags = ({
  tagColor = "green",
  tags = [],
  onClick = console.log,
  ...props
}) => /*#__PURE__*/React.createElement(FlexBox, null, tags.map((tag, i) => /*#__PURE__*/React.createElement(Tag, _extends({
  key: i,
  disabled: tag.disabled,
  color: tagColor
}, props), /*#__PURE__*/React.createElement(P, null, !!tag.label ? tag.label : tag), !tag.disabled && /*#__PURE__*/React.createElement(IconContainer, {
  onClick: () => onClick(i)
}, /*#__PURE__*/React.createElement(RemoveIcon, {
  form: true,
  name: "Remove"
}), /*#__PURE__*/React.createElement(RemoveCircleIcon, {
  form: true,
  name: "RemoveCircle"
})))));
export const Tag = styled(FlexBox)`
  border-radius: 4px;
  padding: 9px 12px;
  background-color: ${props => props.disabled ? props.theme.palette.gray.lightest : props.theme.palette[props.color].primary};
  ${P} {
    color: ${props => props.disabled ? props.theme.palette.gray.lighter : "#ffffff"};
  }
  & + & {
    margin-left: 8px;
  }
`;
const RemoveIcon = styled(Icon)`
  margin-left: 8px;
  path {
    fill: #ffffff;
  }
`;
const RemoveCircleIcon = styled(RemoveIcon)`
  display: none;
`;
const IconContainer = styled.div`
  color: #ffffff;
  cursor: pointer;
  display: flex;
  flex: 0 0 16px;
  height: 16px;
  margin-top: 3px;
  &:hover {
    ${RemoveIcon} {
      display: none;
    }
    ${RemoveCircleIcon} {
      display: block;
    }
  }
`;